// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IClaimEscalationNoteResponseDto
 */
export interface IClaimEscalationNoteResponseDto {
    /**
     * 
     * @type {string}
     * @memberof IClaimEscalationNoteResponseDto
     */
    note?: string;
    /**
     * 
     * @type {Date}
     * @memberof IClaimEscalationNoteResponseDto
     */
    created_at?: Date;
    /**
     * 
     * @type {number}
     * @memberof IClaimEscalationNoteResponseDto
     */
    created_by_contact_id?: number;
}

/**
 * Check if a given object implements the IClaimEscalationNoteResponseDto interface.
 */
export function instanceOfIClaimEscalationNoteResponseDto(value: object): value is IClaimEscalationNoteResponseDto {
    return true;
}

export function IClaimEscalationNoteResponseDtoFromJSON(json: any): IClaimEscalationNoteResponseDto {
    return IClaimEscalationNoteResponseDtoFromJSONTyped(json, false);
}

export function IClaimEscalationNoteResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IClaimEscalationNoteResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'note': json['note'] == null ? undefined : json['note'],
        'created_at': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'created_by_contact_id': json['createdByContactId'] == null ? undefined : json['createdByContactId'],
    };
}

export function IClaimEscalationNoteResponseDtoToJSON(json: any): IClaimEscalationNoteResponseDto {
    return IClaimEscalationNoteResponseDtoToJSONTyped(json, false);
}

export function IClaimEscalationNoteResponseDtoToJSONTyped(value?: IClaimEscalationNoteResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'note': value['note'],
        'createdAt': value['created_at'] == null ? undefined : ((value['created_at']).toISOString()),
        'createdByContactId': value['created_by_contact_id'],
    };
}

